<template>
  <CHeader fixed light with-subheader>
    <CToggler
        @click="$store.commit('toggleSidebarMobile')"
        class="ml-3 d-lg-none"
        in-header
    />
    <CToggler
        @click="$store.commit('toggleSidebarDesktop')"
        class="ml-3 d-md-down-none"
        in-header
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      MFU
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink href="https://www.mfu.ac.th/" target="_blank">
          Mae Fah Luang University
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/mfu/dashboard">
          {{ name }}
        </CHeaderNavLink>
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt :userDetail="userDetail"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  props: {
    name: String,
    userDetail: Object
  },
  components: {
    TheHeaderDropdownAccnt
  }
}
</script>
